import { render, staticRenderFns } from "./rewardsPunishments.vue?vue&type=template&id=53f6a912"
import script from "./rewardsPunishments.vue?vue&type=script&lang=js"
export * from "./rewardsPunishments.vue?vue&type=script&lang=js"
import style0 from "./rewardsPunishments.vue?vue&type=style&index=0&id=53f6a912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports